const getOrCreateTooltip = (chart) => {
  let tooltipElement = chart.canvas.parentNode.querySelector("div");

  if (!tooltipElement) {
    tooltipElement = document.createElement("div");
    tooltipElement.style.background = "white";
    tooltipElement.style.boxShadow =
      "0px 6px 10px -4px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(40, 40, 40, 0.1)";
    tooltipElement.style.borderWidth = "1px";
    tooltipElement.style.borderRadius = "3px";
    tooltipElement.style.color = "black";
    tooltipElement.style.maxWidth = "118px";
    tooltipElement.style.width = "100%";
    tooltipElement.style.opacity = 1;
    tooltipElement.style.pointerEvents = "none";
    tooltipElement.style.position = "absolute";
    tooltipElement.style.transform = "translate(-100%, 0)";
    tooltipElement.style.transition = "all .1s ease";

    const table = document.createElement("table");
    table.style.margin = "0px";

    tooltipElement.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
};

export const doctorChartTooltipHandler = (context) => {
  const label = context.tooltip.dataPoints?.[0]?.label;
  const colors = context.tooltip.dataPoints?.[0]?.dataset?.backgroundColor;

  // Tooltip Element
  const { chart, tooltip } = context;
  const tooltipElement = getOrCreateTooltip(chart);

  const bodyLines = tooltip.body.map((b) => b.lines);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const table = tooltipElement.querySelector("table");

    const firstRow = document.createElement("tr");

    const titleElement = document.createElement("td");
    titleElement.colSpan = 3;
    titleElement.textContent = label;
    titleElement.style.fontSize = "16px";
    titleElement.style.fontFamily = "Roboto";
    if (bodyLines.length === 1) {
      const colorElement = document.createElement("td");
      const span = document.createElement("span");

      span.style.background = colors;
      span.style.borderWidth = "2px";
      span.style.borderRadius = "50%";
      span.style.marginRight = "5px";
      span.style.width = "10px";
      span.style.height = "10px";
      span.style.display = "block";

      colorElement.appendChild(span);
      firstRow.appendChild(colorElement);
    }

    firstRow.appendChild(titleElement);

    // Remove old children
    while (table.firstChild) {
      table.firstChild.remove();
    }

    // Add new children
    table.appendChild(firstRow);

    bodyLines.forEach((body, i) => {
      const secondRow = document.createElement("tr");

      if (bodyLines.length > 1) {
        const colors = tooltip.labelColors[i];
        const colorElement = document.createElement("td");
        const span = document.createElement("span");

        span.style.background = colors.backgroundColor;
        span.style.borderWidth = "2px";
        span.style.borderRadius = "50%";
        span.style.marginRight = "5px";
        span.style.width = "10px";
        span.style.height = "10px";
        span.style.display = "block";

        colorElement.appendChild(span);
        secondRow.appendChild(colorElement);

        const ledgendElement = document.createElement("td");
        ledgendElement.textContent = body?.[0].split(":")[0] || "";
        ledgendElement.style.fontSize = "14px";
        ledgendElement.style.fontWeight = 500;
        secondRow.appendChild(ledgendElement);
      } else {
        const space = document.createElement("td");
        secondRow.appendChild(space);
      }

      const valueElement = document.createElement("td");
      valueElement.textContent = body?.[0].split(":")[1] || "";
      valueElement.style.fontSize = "14px";
      valueElement.style.fontWeight = 400;
      valueElement.style.paddingLeft = "10px";

      secondRow.appendChild(valueElement);
      table.appendChild(secondRow);
    });
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipElement.style.opacity = 1;
  tooltipElement.style.left = positionX + tooltip.caretX + "px";
  tooltipElement.style.top = positionY + tooltip.caretY + "px";
  tooltipElement.style.font = tooltip.options.bodyFont.string;
  tooltipElement.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px";
};
